import http from './http'

export default {
  async get () { return (await http.get('/Telas/PainelOperacional/Get')).data }
}
